import { Link, navigate } from 'gatsby';
import React, { FormEvent, useState } from 'react';
import ProductCategories from './SiteNav';
import logo1x from '../images/logo@1x.png';
import logo2x from '../images/logo@2x.png';

const Header = () => {
  const [query, setQuery] = useState('');
  const doSearch = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    navigate(`/search/?q=${encodeURIComponent(query)}`);
  };
  return (
    <>
      <div className="header grid-container">
        <div className="grid-x grid-margin-x grid-padding-x align-bottom">
          <div className="cell large-4 show-for-medium">
            <small>
              Questions? Need help? Email us at
              customerservice@mountainvalleygrowers.com
            </small>
          </div>
          <div className="cell large-4">
            <Link to="/" className="logo">
              <img
                src={logo1x}
                srcSet={`${logo2x} 2x`}
                alt="Mountain Valley Growers logo"
              />
            </Link>
          </div>
          <div className="cell medium-8 medium-offset-2 large-4 large-offset-0">
            <form onSubmit={doSearch}>
              <div className="input-group float-right">
                <input
                  className="input-group-field"
                  type="text"
                  placeholder="Search for plants"
                  aria-label="Search"
                  name="q"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
                <div className="input-group-button">
                  <button className="button secondary">Search</button>
                </div>
              </div>
            </form>
          </div>
          <nav className="cell site-nav" aria-label="main menu">
            <ProductCategories />
          </nav>
        </div>
      </div>
    </>
  );
};
export default Header;
